import React, { Component } from "react";

class NotApprovedPage extends Component {
    render() {
        return (
            <div className="text-center mt-5">
                <h2>Organizația nu a fost aprobată</h2>
                <p>Te rugăm să contactezi administratorul sau să revii mai târziu.</p>
            </div>
        );
    }
}

export default NotApprovedPage;
